import { Product } from "./product.model";

export class VendorProductLookup {
    public vendorId: number;
    public productId: number;
    public vendorProductId: string;
    public product: Product;

    public constructor(init?: Partial<VendorProductLookup>) {
        Object.assign(this, init);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/models/vendor-product-lookup.model.ts